const spriteStyles = require('owa-sprite/dist/styles/fileType_sprite.css');

export function getCloudIconCSSForAttachment(
    extension: string,
    contentType: string,
    isBlocked: boolean,
    isFolder: boolean,
    embeddedItemClass: string
): string {
    const useSpecialCloud =
        !isBlocked &&
        (isFolder ||
            extensionsThatNeedSpecialCloud.indexOf(extension) !== -1 ||
            contentTypesThatNeedSpecialCloud.indexOf(contentType) !== -1 ||
            embeddedItemClass === 'IPM.Note');

    if (useSpecialCloud) {
        return spriteStyles['fileType-icon-modifiedCloud_32x32'];
    }

    return spriteStyles['fileType-icon-cloud_32x32'];
}

const extensionsThatNeedSpecialCloud: string[] = [
    '3g2',
    '3gp',
    '.asf',
    '.asx',
    '.avi',
    '.bmp',
    '.dib',
    '.email',
    '.eml',
    '.flv',
    '.gif',
    '.ico',
    '.jfif',
    '.jpe',
    '.jpeg',
    '.jpg',
    '.m1v',
    '.mov',
    '.mp4',
    '.mpe',
    '.mpeg',
    '.mpg',
    '.mpv2',
    '.msg',
    '.png',
    '.psd',
    '.rpmsg',
    '.srt',
    '.swf',
    '.tif',
    '.tiff',
    '.vob',
    '.wmd',
    '.wms',
    '.wmv',
    '.wmz',
];

const contentTypesThatNeedSpecialCloud: string[] = [
    'application/vnd.google-apps.document',
    'application/vnd.google-apps.spreadsheet',
    'application/vnd.google-apps.presentation',
    'application/vnd.google-apps.form',
];
